import type { StreamTaskStatusTarget } from './stream-task-status-target';
import type { UnifiedTasksContainerDep } from './types';

/** Builds a {@link StreamTaskStatusTarget} from the unified-tasks container dep. */
export const buildUnifiedStreamTaskTarget = (
	unifiedTasksActions: UnifiedTasksContainerDep,
): StreamTaskStatusTarget => ({
	createTaskFromStream: (args) => unifiedTasksActions.createTaskFromStream(args),
	setTaskProgressState: (args) => unifiedTasksActions.setTaskProgressState(args),
});
